export const ROLE_LABELS = {
  admin: "Workshop Manager",
  supervisor: "Supervisor",
  technician: "Technician",
  inventory_manager: "Inventory & Procurement",
};

export const BRANCHES = [
  { value: "army", label: "Army", color: "#4D7C0F" },
  { value: "navy", label: "Navy", color: "#1E40AF" },
  { value: "air_force", label: "Air Force", color: "#0284C7" },
  { value: "commercial", label: "Commercial", color: "#6B7280" },
];

export const CLASSIFICATIONS = [
  { value: "unclassified", label: "UNCLASSIFIED", cls: "bg-slate-500/15 text-slate-500 border-slate-500/30" },
  { value: "restricted", label: "RESTRICTED", cls: "bg-blue-500/15 text-blue-500 border-blue-500/30" },
  { value: "confidential", label: "CONFIDENTIAL", cls: "bg-amber-500/15 text-amber-600 dark:text-amber-400 border-amber-500/30" },
  { value: "secret", label: "SECRET", cls: "bg-red-500/20 text-red-600 dark:text-red-400 border-red-500/40 font-bold" },
];

export const JOB_STATUSES = [
  { value: "received", label: "Received", cls: "bg-slate-500/15 text-slate-500 border-slate-500/30" },
  { value: "in_diagnosis", label: "In Diagnosis", cls: "bg-cyan-500/15 text-cyan-600 dark:text-cyan-400 border-cyan-500/30" },
  { value: "awaiting_parts", label: "Awaiting Parts", cls: "bg-amber-500/15 text-amber-600 dark:text-amber-400 border-amber-500/30" },
  { value: "testing", label: "Testing", cls: "bg-indigo-500/15 text-indigo-500 border-indigo-500/30" },
  { value: "qa_review", label: "QA Review", cls: "bg-purple-500/15 text-purple-500 border-purple-500/30" },
  { value: "ready_for_dispatch", label: "Ready for Dispatch", cls: "bg-emerald-500/15 text-emerald-600 dark:text-emerald-400 border-emerald-500/30" },
  { value: "dispatched", label: "Dispatched", cls: "bg-green-700/15 text-green-700 dark:text-green-400 border-green-700/30" },
];

export const PRIORITIES = [
  { value: "low", label: "Low", cls: "text-slate-500" },
  { value: "normal", label: "Normal", cls: "text-blue-500" },
  { value: "high", label: "High", cls: "text-amber-500" },
  { value: "urgent", label: "Urgent", cls: "text-red-500" },
];

export const REPAIR_TYPES = [
  { value: "new_repair", label: "New Repair", cls: "bg-sky-500/15 text-sky-600 dark:text-sky-400 border-sky-500/30" },
  { value: "warranty_repair", label: "Warranty Repair", cls: "bg-orange-500/15 text-orange-600 dark:text-orange-400 border-orange-500/30" },
];

export const PROJECT_STATUSES = ["planning", "active", "testing", "completed", "archived"];
export const PO_STATUSES = ["draft", "ordered", "partially_received", "received", "cancelled"];
export const KANBAN_COLUMNS = [
  { value: "backlog", label: "Backlog / Inward" },
  { value: "diagnosis", label: "Fault Diagnosis" },
  { value: "repair", label: "Component Repair" },
  { value: "qa", label: "QA Testing" },
  { value: "done", label: "Done / Outward" },
];

export const REPAIR_OUTCOMES = [
  { value: "repaired", label: "Repaired" },
  { value: "ber", label: "Beyond Economical Repair (BER)" },
  { value: "returned_unrepaired", label: "Returned Unrepaired" },
  { value: "replaced_warranty", label: "Replaced under Warranty" },
];

export function findMeta(list, value) {
  return list.find((x) => x.value === value) || { label: value, cls: "" };
}

export function fmtMoney(n) {
  return "₹" + Number(n || 0).toLocaleString("en-IN");
}

// Prefers prior outward warranty (starts at dispatch); falls back to supply date + months.
export function warrantyStatus(job) {
  if (!job || job.repair_type !== "warranty_repair") return null;
  const pw = job.prior_warranty;
  if (pw && pw.warranty_until) {
    const daysOver = Math.floor((Date.now() - new Date(pw.warranty_until).getTime()) / 86400000);
    return { expired: daysOver > 0, expiry: pw.warranty_until, daysOver, months: pw.warranty_period, source: "outward", from: pw.job_number, start: pw.dispatch_date };
  }
  if (!job.supply_date) return null;
  const months = Number(job.warranty_period_months || 12);
  const expiry = new Date(job.supply_date);
  expiry.setMonth(expiry.getMonth() + months);
  const daysOver = Math.floor((Date.now() - expiry.getTime()) / 86400000);
  return { expired: daysOver > 0, expiry: expiry.toISOString(), daysOver, months: `${months} mo`, source: "supply", start: job.supply_date };
}


export function fmtDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("en-IN", { day: "2-digit", month: "short", year: "2-digit", hour: "2-digit", minute: "2-digit" });
  } catch {
    return iso;
  }
}

export function branchColor(b) {
  return (BRANCHES.find((x) => x.value === b) || {}).color || "#6B7280";
}
